import React from 'react';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { keyframes } from '@mui/material/styles';

import { AutoRefreshProps } from './Pagination.v4.props';

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const INTERVAL_OPTIONS = [
  { value: 0, label: 'Off' },
  { value: 30, label: '30s' },
  { value: 60, label: '1m' },
  { value: 300, label: '5m' },
] as const;

export const AutoRefresh: React.FC<AutoRefreshProps> = ({ interval, onChange }) => {
  const isActive = interval > 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {isActive && (
        <Box
          aria-label="Auto-refresh active"
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'success.main',
            animation: `${pulse} 2s ease-in-out infinite`,
          }}
        />
      )}
      <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>Auto-refresh:</Typography>
      <Select
        size="small"
        value={interval}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label="Auto-refresh interval"
        sx={{
          fontSize: '12px',
          height: 28,
          minWidth: 70,
          '& .MuiSelect-select': { py: 0.25, px: 1 },
        }}
      >
        {INTERVAL_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: '12px' }}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
